import actionTypes from '../../actions/actionTypes'
import { Map } from 'immutable';

const INIT_STATE = Map({
    activeTab: 'left'
})

function setActiveTab(state, action){
    return state.set('activeTab', action.payload.activeTabID);
}

function printReducer(state = INIT_STATE, action) {
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.PRINT_SET_ACTIVE_TAB:
            return setActiveTab(state, action);
        default:
            return state;
    }
}

export default printReducer;